import { model, ListModel, createThunk } from 'mst-collection';

import { Api, schemas } from '@api';
import { SectionModel } from './SectionModel';

export class MyHubSectionsList extends ListModel(SectionModel, {
  schema: schemas.SectionListSchema,
}) {
  fetch = createThunk(() => {
    return async function fetch(this: MyHubSectionsList) {
      const res = await Api.Sections.getMyHubSections();

      this.set(res.data.sections);
    };
  });

  /**
   * Extra ThunkModel for UI purposes
   */
  refresh = createThunk(() => {
    return async function refresh(this: MyHubSectionsList) {
      await this.fetch.run();
    };
  });
}

export const MyHubSectionsListModel = model(MyHubSectionsList);
